/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getRepostedBy.defs.js'
export * as $defs from './getRepostedBy.defs.js'
